// extracted by mini-css-extract-plugin
export default {"form-select-container":"FormSelect_form-select-container__kp5Ez"};